import { Component } from '@angular/core';
import { Product } from 'app/models/Product';
import { PollinatorService } from '../services/pollinator.service';

@Component({
  selector: 'app-pollinator',
  templateUrl: './pollinators.component.html',
  styleUrls: ['./pollinators.component.scss']
})

export class PollinatorComponent {
  activePollinator = 'bee';
  plants: Product[] = [];
  pagination: any = {};
  currentPage = 1;
  perPage = 25;

  pollinator_1 = '/assets/images/pollinator-1.png';
  pollinator_2 = '/assets/images/pollinator-2.png';

  bees = '/assets/images/Stickers-Bee.png';
  butterflies = '/assets/images/Stickers-Butterfly.png';
  hummingbirds = '/assets/images/Stickers-Hummingbird.png';

  bees_card_bg = '/assets/images/bee-button.png';
  butterflies_card_bg = '/assets/images/butterfly-button.png';
  hummingbirds_card_bg = '/assets/images/hummingbird-button.png';

  pollinators: {title: string, slug: string, image: string, card_bg: string}[] = [
    {title: 'Bees', slug: 'bee', image: this.bees, card_bg: this.bees_card_bg},
    {title: 'Butterflies', slug: 'butterfly', image: this.butterflies, card_bg: this.butterflies_card_bg},
    {title: 'Hummingbirds', slug: 'hummingbird', image: this.hummingbirds, card_bg: this.hummingbirds_card_bg}
  ];

  sourcesShown: { [plantId: number]: boolean } = {};

  constructor(private pollinatorService: PollinatorService) {}

  setActivePollinator(pollinator: string) {
    this.activePollinator = pollinator;
    this.fetchPlants(this.currentPage, this.perPage);
  }

  ngOnInit() {
    this.fetchPlants(this.currentPage, this.perPage);
  }

  fetchPlants(page: number, perPage: number) {
    this.pollinatorService.getPollinatorData(this.activePollinator, page, perPage).subscribe({
      next: ({ plants, pagination }) => {
        this.plants = plants;
        this.pagination = pagination;
        this.currentPage = pagination.current_page;
      },
      error: err => {
        console.error('Error fetching pollinator data:', err);
      }
    });
  }

  onPageChange(page: number) {
    this.fetchPlants(page, this.perPage);
  }

  onPerPageChange(perPage: number) {
    this.perPage = perPage;
    this.fetchPlants(1, this.perPage);
  }

  capitalize(value: string) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  removeUnderscores(value: string) {
    return value.replace(/_/g, ' ');
  }

  toggleSources(plantId: number) {
    this.sourcesShown[plantId] = !this.sourcesShown[plantId];
  }
}
